// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import List from '@material-ui/core/List';
import Box from "@material-ui/core/Box";
import Header from '../Sidebar/Header';
import Messages from '../Messages';
import { OptionsProvider } from './context';
import Option from './Option';
import Config from './Config';
import MapConfig from './MapConfig';
import Users from './Users';
import WeatherDataExpiration from './WeatherDataExpiration';

export type Props = $ReadOnly<{

}>;

function Options() {
    return (
        <List subheader={(
            <Header
                title={(
                    <Box fontSize="h6.fontSize">
                        <FormattedMessage
                            id="sidebar.options.header"
                            defaultMessage="Options"
                        />
                    </Box>
                )}
            />
        )}>

            <OptionsProvider>
                <Option
                    label={(
                        <FormattedMessage
                            id="sidebar.options.button.users"
                            defaultMessage="Users"
                        />
                    )}
                >
                    <Users />
                </Option>

                <Option
                    label={(
                        <FormattedMessage
                            id="sidebar.options.button.map"
                            defaultMessage="Map"
                        />
                    )}
                >
                    <MapConfig />
                </Option>

                <Option
                    label={(
                        <FormattedMessage
                            id="sidebar.options.button.log"
                            defaultMessage="Message Log"
                        />
                    )}
                >
                    <Messages showAll disableForm />
                </Option>

                <Option
                    label={(
                        <FormattedMessage
                            id="sidebar.options.button.meteoExpiration"
                            defaultMessage="Weather Data expiration"
                        />
                    )}
                >
                    <WeatherDataExpiration />
                </Option>

                <Option
                    label={(
                        <FormattedMessage
                            id="sidebar.options.button.config"
                            defaultMessage="Config"
                        />
                    )}
                >
                    <Config />
                </Option>
            </OptionsProvider>
        </List>
    );
}

export default Options;